import { render, staticRenderFns } from "./AttributeSelect.vue?vue&type=template&id=10a44f72"
import script from "./AttributeSelect.vue?vue&type=script&lang=js"
export * from "./AttributeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports